(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-video-eric"] && !Shopify.designMode) return;
  try {
    
  const lookbookMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateLookbookAutoplay = () => {
    document.querySelectorAll('.collection-lookbook-video__video[autoplay]').forEach((video) => {
      if (lookbookMotionPreference.matches) {
        video.pause();
        video.controls = true;
      } else {
        video.play().catch(() => {});
      }
    });
  };

  updateLookbookAutoplay();
  lookbookMotionPreference.addEventListener('change', updateLookbookAutoplay);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const inputSelector =
      '.template-cart .cart__item-qty-selector input[data-quantity-input]';

    const syncLimit = input => {
      if (!input || input.max === '') return;

      const max = Number(input.max);
      const value = Number(input.value);

      if (!Number.isFinite(max) || !Number.isFinite(value)) return;
      if (value > max) input.value = max;

      const plusButton = input
        .closest('.cart__item-qty-selector')
        ?.querySelector('.cart__item-button--plus');

      if (plusButton) {
        plusButton.disabled = Number(input.value) >= max;
        plusButton.setAttribute(
          'aria-disabled',
          String(plusButton.disabled)
        );
      }
    };

    document.addEventListener(
      'click',
      event => {
        const button = event.target.closest(
          '.template-cart .cart__item-button[data-change]'
        );

        if (!button) return;

        const selector = button.closest('.cart__item-qty-selector');
        const input = selector?.querySelector(
          'input[data-quantity-input]'
        );

        if (!input) return;

        if (
          button.dataset.change === 'increment' &&
          input.max !== ''
        ) {
          const current = Number(input.value);
          const max = Number(input.max);

          if (current >= max) {
            event.preventDefault();
            event.stopImmediatePropagation();
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            return;
          }

          if (current + 1 >= max) {
            requestAnimationFrame(() => syncLimit(input));
          }
        }

        if (button.dataset.change === 'decrement') {
          const plusButton = selector.querySelector(
            '.cart__item-button--plus'
          );

          if (plusButton) {
            plusButton.disabled = false;
            plusButton.setAttribute('aria-disabled', 'false');
          }
        }
      },
      true
    );

    document.addEventListener(
      'input',
      event => {
        if (event.target.matches(inputSelector)) {
          syncLimit(event.target);
        }
      },
      true
    );

    document.querySelectorAll(inputSelector).forEach(syncLimit);
  })();

  } catch(e) { console.error(e); }
})();
})();
